/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useInView } from 'react-intersection-observer'
import { useTranslation } from 'react-i18next'
import useQuery from '../../../../hooks/useQuery'
import { useProfile } from '../../../../hooks'
import { LastPge } from './styled'
import { TASK_CATEGORY_VALUE, DEFAULT_PAGE } from '../../constants'

export const LoadMoreTasks = ({ tasksData, loadMoreTasksAction, page, setPage }) => {
  const { t } = useTranslation()
  const { ref, inView } = useInView()
  const query = useQuery()
  const taskTypeId = query.get('taskTypeId')
  const taskCategoryId = query.get('taskCategoryId')
  const { profile: { userId } } = useProfile()
  const { isLastPage, totalCount } = tasksData
  const totalPages = Math.ceil(totalCount / DEFAULT_PAGE.PER_PAGE)

  useEffect(() => {
    if (inView && !isLastPage && totalPages > page) {
      loadMoreTasksAction({
        page: page + 1,
        taskTypeId: taskTypeId || TASK_CATEGORY_VALUE.MY_TASK,
        referenceId: taskCategoryId || userId
      })
      setPage((prev) => prev + 1)
    }
  }, [inView, isLastPage])

  useEffect(() => {
    setPage(DEFAULT_PAGE.PAGE)
  }, [taskCategoryId])

  if (isLastPage) return <LastPge ref={ref}>{t('task.last_page')}</LastPge>

  return (
    <div ref={ref} />
  )
}

LoadMoreTasks.propTypes = {
  tasksData: PropTypes.object.isRequired,
  loadMoreTasksAction: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  setPage: PropTypes.func.isRequired
}
